export const EntityHistoryEntityTypes = {
  WorkItem: 'WorkItem',
  TestCase: 'TestCase',
} as const

export type EntityHistoryEntityType = typeof EntityHistoryEntityTypes[keyof typeof EntityHistoryEntityTypes]

export const EntityHistoryActions = {
  Created: 'Created',
  Updated: 'Updated',
  Deleted: 'Deleted',
} as const

export type EntityHistoryAction = typeof EntityHistoryActions[keyof typeof EntityHistoryActions]

export interface EntityHistoryFieldChange {
  fieldName: string
  oldValue: string | null
  newValue: string | null
  /** Human-readable stand-in for a value that is a reference, e.g. a user id resolved to a name. */
  oldValueLabel: string | null
  newValueLabel: string | null
}

export interface EntityHistoryEntry {
  changeGroupId: string
  action: EntityHistoryAction
  performedAt: string
  performedByUserId: string | null
  performedByDisplayName: string | null
  performedByEmail: string | null
  changes: EntityHistoryFieldChange[]
}
